if (!customElements.get('gift-note')) {
  class GiftNote extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.gift-note__checkbox');
      this.field = this.querySelector('.gift-note__field');
      this.input = this.querySelector('.gift-note__input');
      this.status = this.querySelector('.gift-note__status');
      this.pending = false;

      this.checkbox.addEventListener('change', () => {
        this.field.hidden = !this.checkbox.checked;
        if (this.checkbox.checked) this.input.focus();
        this.save();
      });
      this.input.addEventListener('input', () => {
        this.pending = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.save(), 600);
      });
      this.input.addEventListener('blur', () => this.flush());
    }

    flush() {
      return this.pending ? this.save() : (this.request || Promise.resolve());
    }

    save() {
      clearTimeout(this.timer);
      this.pending = false;
      const on = this.checkbox.checked;
      const note = on ? this.input.value.trim() : '';

      this.request = fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Gift': on ? 'Yes' : '', 'Gift note': note } })
      })
        .then((res) => {
          if (!res.ok) throw new Error();
          this.status.textContent = note ? 'Saved' : '';
        })
        .catch(() => {
          this.status.textContent = 'Could not save your note. Please try again.';
        });

      return this.request;
    }
  }
  customElements.define('gift-note', GiftNote);

  // Make sure the note is saved before going to checkout
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[name="checkout"], a[href$="/checkout"]');
    if (!button || button.dataset.giftNoteReady) return;

    const notes = [...document.querySelectorAll('gift-note')];
    if (!notes.some((el) => el.pending || el.request)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    await Promise.all(notes.map((el) => el.flush()));

    button.dataset.giftNoteReady = 'true';
    button.click();
  }, true);
}


// Show or hide the gift note whenever the cart changes
if (!window.__giftNoteSync) {
  window.__giftNoteSync = true;

  const root = window.Shopify?.routes?.root || '/';
  const cartChange = /\/cart\/(add|change|update|clear)/;
  const nativeFetch = window.fetch;
  let timer;

  window.syncGiftNotes = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        const res = await nativeFetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        const cart = await res.json();
        document.querySelectorAll('gift-note').forEach((el) => {
          el.hidden = cart.item_count === 0;
        });
      } catch (e) {}
    }, 200);
  };

  // 1. Cart updates made with fetch
  window.fetch = function (...args) {
    const request = nativeFetch.apply(this, args);
    const input = args[0];
    const url = input instanceof Request ? input.url : String(input);
    if (cartChange.test(url)) {
      request.then(window.syncGiftNotes).catch(() => {});
    }
    return request;
  };

  // 2. Cart updates made with XMLHttpRequest
  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (cartChange.test(String(url))) {
      this.addEventListener('load', window.syncGiftNotes);
    }
    return nativeOpen.call(this, method, url, ...rest);
  };

  // 3. Drawer contents re-rendered by the theme
  const watchDrawer = () => {
    const note = document.querySelector('gift-note');
    const drawer = note && note.closest('[id*="drawer" i], [class*="drawer" i]');
    if (!drawer) return;

    new MutationObserver((mutations) => {
      const changed = mutations.some((m) => !m.target.closest?.('gift-note, .swiper'));
      if (changed) window.syncGiftNotes();
    }).observe(drawer, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
}